<div id="modal"></div>

<app-confirm-close-overlay></app-confirm-close-overlay>
<app-connection-interrupted-overlay></app-connection-interrupted-overlay>
<app-connection-stopped-overlay></app-connection-stopped-overlay>
<app-browser-detect-overlay></app-browser-detect-overlay>
